import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { AuthenticationService } from './_services/authentication.service';
import { Helpers } from '../helpers';
import { ApiService } from '../main/pages/api-service.service';

@Component({
    selector: '',
    templateUrl: './templates/resetpasswordOnce.component.html',
    styleUrls: ['./templates/login-1.component.css'],
    encapsulation: ViewEncapsulation.None,
})

export class ResetPasswordOnceComponent implements OnInit {
    model: any = {};
    loading = false;
    error = '';
    istrue = false;
    isrequest = false
    pMessage = '';
    // returnUrl: '/portfolio';

    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        // private _userService: UserService,
        private _route: ActivatedRoute,
        private _authService: AuthenticationService,
        // private _alertService: AlertService,
        private cfr: ComponentFactoryResolver,
        private Service: ApiService) {
    }
    ngOnInit() {
        this.istrue = true;

    }

    backLogin() {
        this._authService.logout();
        this._router.navigate(['/login']);
    }
    signin() {
        this.istrue = true;
        this.isrequest = false;
        this.pMessage = '';
        this.error = '';
        Helpers.setLoading(true);
        let params: any = {};
        params.current_password = this.model.cpassword;
        params.new_password = this.model.npassword;
        params.re_new_password = this.model.cnpassword;
        this.Service.resetpassword(params).subscribe(result => {
            this.pMessage = 'Your password has been updated';
            Helpers.setLoading(false);
            this.istrue = false;
            this.isrequest = true;
        }, error => {

            if (error.status === 400) {
                let err = error.json();
                if (err['new_password']) {
                    this.error = err['new_password'][0]
                }
                if (err['current_password']) {
                    this.error = err['current_password'][0]
                }
                Helpers.setLoading(false);
            }
        });

        Helpers.setLoading(false);
        this.model.cpassword = '';
        this.model.npassword = '';
        this.model.cnpassword = '';

    }
}


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/auth/resetpasswordOnce.component.ts